/**
 * Financial utility functions for cost formatting
 */

/**
 * Formats euros with Finnish locale formatting
 * @param euros - Amount in euros (can be string from database decimal or number)
 * @returns Formatted string (e.g., "150,00 €")
 */
export function formatEuros(euros: string | number | null | undefined): string {
  if (euros === null || euros === undefined) return '0,00 €'
  const amount = typeof euros === 'string' ? parseFloat(euros) : euros
  return `${amount.toFixed(2).replace('.', ',')} €`
}
